import { SET_USER } from 'redux/actionTypes';

export default function user(state = {}, action) {
    switch(action.type) {
        case SET_USER:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};